<md-content-box class="profile-info-box">
	<div class="left">
		<ng-content select="[left]"></ng-content>
	</div>

	<div class="right">
		<md-icon [icon]="infoBoxIcon()"></md-icon>
		<div class="form-fields">
			<ng-content select="[right]"></ng-content>
		</div>
	</div>
</md-content-box>
